import * as React from 'react';
import { withStyles, WithStyles, Theme, createStyles } from '@material-ui/core';
import { withIntl, IntlProps } from 'ha/i18n';
import Grid from 'ha/ui/next/Grid';
import units from 'ha/theme/units';
import { Label, StyledTab, StyledTabs, TabPanel } from './StyledTabs';
import Testimonial from './Testimonial';
import HowItWorks from './HowItWorks';

export const styles = (t: Theme) =>
  createStyles({
    root: {
      marginTop: units.rem(2.5),

      [t.breakpoints.up('md')]: {
        marginTop: units.rem(5),
      },
    },
    tabs: {
      padding: units.yx(0, 0.5),
      marginBottom: units.rem(4),
    },
    activeTab: {
      color: '#8e5082',
    },
    howItWorksSection: {
      marginBottom: units.rem(3.75),

      [t.breakpoints.up('md')]: {
        marginBottom: units.rem(6.25),
      },
    },
  });

export class InfoSection extends React.Component<
  IntlProps & WithStyles<typeof styles>
> {
  state = {
    currentTabIndex: 0,
  };

  handleTabChange = (
    _: React.ChangeEvent<HTMLSelectElement>,
    newTabIndex: number,
  ) => {
    // We want to trigger scroll to initialize lazy loading for images
    if (window) {
      window.scrollTo(window.scrollX, window.scrollY - 1);
      window.scrollTo(window.scrollX, window.scrollY + 1);
    }

    this.setState({ currentTabIndex: newTabIndex });
  };

  render() {
    const { currentTabIndex } = this.state;
    const {
      intl: { T },
      classes,
    } = this.props;

    return (
      <div className={classes.root}>
        <Grid container justify="center" className={classes.tabs}>
          <StyledTabs value={currentTabIndex} onChange={this.handleTabChange}>
            <StyledTab
              label={<Label>{T('home_page_info_section_for_tenants')}</Label>}
              selectedClassName={classes.activeTab}
              data-test-locator="Home InfoSection StyledTab ForTenants"
            />
            <StyledTab
              label={<Label>{T('home_page_info_section_for_landlords')}</Label>}
              selectedClassName={classes.activeTab}
              data-test-locator="Home InfoSection StyledTab ForLandlords"
            />
          </StyledTabs>
        </Grid>
        <TabPanel
          currentTabIndex={currentTabIndex}
          index={0}
          data-test-locator="Home InfoSection TabPanel ForTenants"
        >
          <div className={classes.howItWorksSection}>
            <HowItWorks
              data-test-locator="Home InfoSection HowItWorks ForTenants"
              isTenant
            />
          </div>
          <Testimonial
            data-test-locator="Home InfoSection Testimonial ForTenants"
            isTenant
          />
        </TabPanel>
        <TabPanel
          currentTabIndex={currentTabIndex}
          index={1}
          data-test-locator="Home InfoSection TabPanel ForLandlords"
        >
          <div className={classes.howItWorksSection}>
            <HowItWorks data-test-locator="Home InfoSection HowItWorks ForLandlords" />
          </div>
          <Testimonial data-test-locator="Home InfoSection Testimonial ForLandlords" />
        </TabPanel>
      </div>
    );
  }
}

export default withStyles(styles)(withIntl(InfoSection));
